import axios from 'axios';

export const EmailMessageService = {
  // Show Mail
  readMail: (item: any, pageNum: number, pagesize: number) =>
    axios.post(
      `/Emails/readMail?email=${item}&pageNo=${pageNum}&pageSize=${pagesize}`,
    ),
  unReadMail: (item: any, pageNum: number, pagesize: number) =>
    axios.post(
      `/Emails/unReadMail?email=${item}&pageNo=${pageNum}&pageSize=${pagesize}`,
    ),
  // Mail Count
  readMailCount: (item: any) =>
    axios.get(`/Emails/readMailCount?email=${item}`),
  unReadMailCount: (item: any) => axios.get(`Emails/unReadMailCount?email=${item}`),
  // sort Array
  unReadMailSort: (
    item: any,
    ascending: boolean,
    pageNum: number,
    pagesize: number,
  ) =>
    axios.get(
      `/Emails/unReadMailSort?name=${item}&ascending=${ascending}&pageNo=${pageNum}&pageSize=${pagesize}`,
    ),
  readMailSort: (
    item: any,
    ascending: boolean,
    pageNum: number,
    pagesize: number,
  ) =>
    axios.get(
      `/Emails/readMailSort?name=${item}&ascending=${ascending}&pageNo=${pageNum}&pageSize=${pagesize}`,
    ),
  // changeRead
  EmailRead: (id: string) => axios.put(`/Emails/read?Id=${id}`),
  emailSearchAPI: (params: {
    item: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/Emails/search`, { params }),
  emailCountAPI: (params: { item: string }) =>
    axios.get<any>(`/Emails/count`, { params }),
};
